<!-- <div class="row">
    <h4>Extrusion Baseplane</h4>
</div> -->

<mat-card class="dialog-card">
    <mat-card-content>
        <div fxLayout="row" fxLayoutGap="16px">
            <div fxFlex="85">

                <!-- Drawing Tools Toolbar -->
                <div class="drawing-tools-toolbar">
                    <mat-button-toggle-group [(ngModel)]="currentTool" (change)="setTool($event.value)" aria-label="Drawing Tools">
                        <mat-button-toggle value="select" matTooltip="Select Tool">
                            <mat-icon>mouse</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle value="line" matTooltip="Line Tool">
                            <mat-icon>timeline</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle value="spline" matTooltip="Spline/Curve Tool">
                            <mat-icon>gesture</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle value="circle" matTooltip="Circle Tool (for holes)">
                            <mat-icon>radio_button_unchecked</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>



                    <span class="tool-info" *ngIf="isDrawing">
                        <mat-icon>info</mat-icon>
                        <span *ngIf="currentTool === 'line'">Click to set end point</span>
                        <span *ngIf="currentTool === 'circle'">Click to set radius</span>

                    </span>

                    <span class="tool-info" *ngIf="currentTool === 'line' && !isDrawing && shapes[currentShapeIndex]?.type === 'hole' && shapes[currentShapeIndex]?.points?.length === 0">
                        <mat-icon>info</mat-icon>
                        <span>Click to start drawing the hole shape. Double-click to close.</span>
                    </span>

                    <span class="tool-info" *ngIf="currentTool === 'select' && !isDrawing">
                        <mat-icon>info</mat-icon>
                        <span>Click points to select. Drag empty space for rectangle selection. Ctrl+Click for multi-select.</span>
                    </span>



                    <button mat-icon-button matTooltip="Keyboard Shortcuts: S=Select, L=Line, C=Circle, Esc=Clear Selection, Delete/Backspace=Remove Points, Ctrl+Click=Multi-select, Drag=Rectangle Select"
                        class="help-button">
                        <mat-icon>help_outline</mat-icon>
                    </button>
                </div>

                <div #threeContainer class="three-container">
                    <canvas #threeCanvas (mousemove)="this.mousemove($event)" (mouseup)="this.mouseup($event)" (mousedown)="this.svgMouseDown($event)" (wheel)="this.onWheel($event)"
                        (contextmenu)="$event.preventDefault()" style="width: 100%; height: 100%;"></canvas>
                </div>

                <div>
                    <mat-form-field class="shape-select">
                        <mat-label>Select Shape</mat-label>
                        <mat-select [(ngModel)]="currentShapeIndex" (selectionChange)="selectShape($event.value)" name="selectedShape">
                            <mat-option *ngFor="let shape of shapes; let i = index" [value]="i" [matTooltip]="getShapeTooltip(shape)">
                                {{ getShapeButtonText(shape) }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button mat-stroked-button color="primary" (click)="addHole()" matTooltip="Add Hole: Creates new hole and switches to line tool"><i class="fa-solid fa-plus"></i> Draw Hole</button>
                    <button mat-stroked-button color="warn" (click)="removeCurrentShape()" [disabled]="shapes[currentShapeIndex]?.type === 'main'" matTooltip="Remove Hole"><i class="fa-solid fa-minus"></i></button>



                    <mat-form-field class="radius-field" style="width:50px;">
                        <mat-label>Radius</mat-label>
                        <input matInput type="number" [(ngModel)]="cornerRadius" min="1">
                    </mat-form-field>
                    <button mat-stroked-button (click)="makeRoundCorner()" [disabled]="currentPointIndex === -1 || !shapes[currentShapeIndex] || shapes[currentShapeIndex].points.length < 3">
                        Round Corner
                    </button>
                </div>
            </div>

            <div fxFlex="15" class="sidebar">
                <h5 class="sidebar-title">Points for: {{ getCurrentShapeName() }}</h5>
                <div class="hot-container" #hotContainer1 style="height:100%;max-height:300px;overflow:auto;">

                    <!-- Handsontable will be initialized here by the component -->
                </div>

                <div class="sidebar-controls">
                    <button mat-stroked-button (click)="this.addPoint()" matTooltip="Add Point"><i class="fa-solid fa-plus"></i></button>
                    <button mat-stroked-button (click)="this.removePoint()" [disabled]="!shapes[currentShapeIndex] || shapes[currentShapeIndex].points.length === 0" matTooltip="Remove Point(s)"><i
                            class="fa-solid fa-minus"></i></button>

                    <!-- Multi-selection info -->
                    <div class="selection-status" *ngIf="selectedPoints.length > 0">
                        <small><strong>{{selectedPoints.length}} points selected</strong></small>
                        <small>Ctrl+Click to select/deselect points</small>
                        <small>Use Remove button to delete selected points</small>
                    </div>
                    <mat-checkbox [(ngModel)]="snap" class="sidebar-checkbox">Snap to Grid</mat-checkbox>
                    <mat-form-field class="grid-size-field">
                        <mat-label>Grid Size</mat-label>
                        <input matInput type="number" [(ngModel)]="gridsize" (change)="gridchange()">
                    </mat-form-field>

                    <mat-form-field class="sidebar-input-short">
                        <mat-label>Spline Divisions</mat-label>
                        <input matInput type="number" [(ngModel)]="shapes[currentShapeIndex].splineDivisions" (ngModelChange)="updateData()" placeholder="e.g., 30" min="2"
                            matTooltip="Number of segments for the spline visualization. Default is 30.">
                    </mat-form-field>

                    <mat-checkbox [(ngModel)]="copytable" (change)="updateData()" class="sidebar-checkbox">Copy Table
                        with References</mat-checkbox>
                    <mat-form-field class="cell-ref-field">
                        <mat-label>Cell Address</mat-label>
                        <input matInput type="text" [(ngModel)]="cellref" (change)="updateData()">
                    </mat-form-field>


                </div>
            </div>
        </div>
    </mat-card-content>

    <mat-card-actions class="dialog-actions">
        <!-- <label>Output Value</label> -->
        <textarea matInput class="form-control" type="text" [(ngModel)]="value1" style="width:100%;height:100px;"></textarea>
        <button mat-stroked-button (click)="this.dialogRef.close()">Cancel</button>
        <button mat-flat-button color="primary" (click)="apply()">Apply</button>
    </mat-card-actions>
</mat-card>

<style>
    .dialog-card {
        max-width: 1200px;
        /* Adjust as needed */
        margin: auto;
    }

    .three-container {
        width: 100%;
        /* Make it responsive */
        height: 600px;
        /* Or adjust as needed */
        position: relative;
        border: 1px solid #ccc;
        margin-bottom: 16px;
    }

    .controls-toolbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
        padding: 8px;
        /* Add some padding */
        background-color: #f5f5f5;
        /* Light background for the toolbar */
        border-radius: 4px;
    }

    .shape-toggle-group .mat-button-toggle {
        min-width: 40px;
        padding: 0 8px;
        line-height: 36px;
        /* Adjusted for standard mat-button-toggle height */
        height: 36px;
        /* Standard mat-button-toggle height */
    }

    .shape-toggle-group .active-shape {
        background-color: var(--mat-option-selected-state-label-text-color);
        /* Use Angular Material's primary color or a custom one */
        color: var(--mat-option-selected-state-label-text-color);
    }

    .radius-field,
    .grid-size-field,
    .cell-ref-field {
        width: 120px;
        /* Consistent width for small inputs */
    }

    .sidebar {
        padding-left: 16px;
        border-left: 1px solid #eee;
    }

    .sidebar-title {
        margin-top: 0;
        /* Remove default margin if using fxLayoutGap */
        margin-bottom: 16px;
    }

    .hot-container {
        width: 100%;
        height: 300px;
        /* Adjust as needed */
        margin-bottom: 16px;
    }

    .sidebar-controls {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .sidebar-controls .mat-stroked-button {
        width: 100%;
        /* Make buttons full width in sidebar */
    }

    .sidebar-checkbox {
        margin-top: 8px;
    }

    .dialog-actions {
        padding: 16px;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        border-top: 1px solid #eee;
        /* Separator line */
    }

    .dialog-actions .mat-form-field {
        margin-right: auto;
        /* Pushes buttons to the right */
    }

    .sidebar-input-full-width {
        width: 100%;
    }

    .drawing-tools-toolbar {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 8px;
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        margin-bottom: 8px;
        position: relative;
    }

    .drawing-tools-toolbar mat-button-toggle-group {
        background-color: white;
        border-radius: 4px;
    }

    .tool-info {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #6c757d;
        font-size: 0.875rem;
    }

    .tool-info mat-icon {
        font-size: 16px;
        width: 16px;
        height: 16px;
    }

    .move-tool-controls {
        padding: 12px 0;
        border-top: 1px solid #eee;
        margin-top: 12px;
    }

    .move-tool-controls h6 {
        margin: 0 0 8px 0;
        font-size: 0.875rem;
        font-weight: 500;
        color: #333;
    }

    .move-tool-controls button {
        width: 100%;
        margin-bottom: 8px;
        font-size: 0.75rem;
    }

    .selection-info {
        padding: 4px 8px;
        background-color: #e3f2fd;
        border-radius: 4px;
        margin-top: 8px;
    }

    .selection-info small {
        color: #1976d2;
        font-weight: 500;
    }

    .help-button {
        position: absolute;
        right: 8px;
        top: 8px;
        opacity: 0.7;
    }

    .help-button:hover {
        opacity: 1;
    }

    .sidebar-input-short {
        width: 120px;
        /* Or similar to other short inputs */
    }

    .selection-status {
        background-color: #e8f5e8;
        border: 1px solid #4caf50;
        border-radius: 4px;
        padding: 8px;
        margin: 8px 0;
    }

    .selection-status small {
        display: block;
        color: #2e7d32;
        font-size: 0.75rem;
        margin: 2px 0;
    }

    .selection-status small:first-child {
        font-weight: bold;
        font-size: 0.8rem;
    }
</style>